/**
 * @file
 * Global utilities.
 *
 */
(function (Drupal, once) {
  'use strict';

  // Navigation toggle.
  Drupal.behaviors.toggleMenu = {
    attach: function (context, settings) {
      once('toggleMenu', 'button.hamburger', context).forEach(toggleButton => {
        toggleButton.addEventListener('click', function (e) {
          e.preventDefault();
          toggleButton.classList.toggle('active');
          const body = context.querySelector('body') || document.body;
          body.classList.toggle('menu-opened');

          // Handle donate button styling
          const donateBtn =
            context.querySelector('header .btns.donate') ||
            document.querySelector('header .btns.donate');
          if (donateBtn) {
            if (body.classList.contains('menu-opened')) {
              donateBtn.classList.add('white');
            } else {
              donateBtn.classList.remove('white');
            }
          }
        });
      });
    },
  };

  // Smooth scrolling for video banner CTA buttons.
  Drupal.behaviors.videoBannerScroll = {
    attach: function (context, settings) {
      once('videoBannerScroll', '.video-banner-scroll-btn', context).forEach(
        scrollButton => {
          scrollButton.addEventListener('click', function (e) {
            e.preventDefault();

            const targetId = this.getAttribute('data-target');
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
              targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
              });
            }
          });
        }
      );
    },
  };

  // Search toggle functionality.
  Drupal.behaviors.searchToggle = {
    attach: function (context, settings) {
      once('searchToggle', '.custom-submit-btn.search-toggle', context).forEach(
        customSubmitBtn => {
          customSubmitBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            // Check if we have the search input element
            const searchInput = document.querySelector(
              '#edit-search-api-fulltext, #edit-search-api-fulltext--2, #edit-search-api-fulltext--3'
            );
            const searchForm = document.querySelector(
              '#views-exposed-form-acquia-search-block-1'
            );

            if (searchInput) {
              // Check if input is active and has text
              if (
                searchInput.classList.contains('active') &&
                searchInput.value.trim() !== ''
              ) {
                // If input has text, trigger search instead of closing
                e.preventDefault();
                e.stopPropagation();

                // Trigger the original search form submission
                const originalSubmitBtn = document.querySelector(
                  '#edit-submit-acquia-search--2, #edit-submit-acquia-search--3'
                );
                if (originalSubmitBtn) {
                  originalSubmitBtn.click();
                }
                return false;
              }

              // Toggle search input visibility
              if (!searchInput.classList.contains('active')) {
                // Show the input and add active class when showing
                searchInput.style.display = 'block';
                searchInput.classList.add('active');
                if (searchForm) {
                  searchForm.classList.add('active');
                }
                // Focus the input after animation starts
                setTimeout(() => {
                  searchInput.focus();
                }, 200);
              } else {
                // Remove active classes to trigger closing transition
                searchInput.classList.remove('active');
                if (searchForm) {
                  searchForm.classList.remove('active');
                }
                // Hide the input after transition completes
                setTimeout(() => {
                  if (!searchInput.classList.contains('active')) {
                    searchInput.style.display = 'none';
                  }
                }, 300);
              }
              return false;
            }
          });
        }
      );

      // Add click handler for close icon on the form container
      once(
        'searchClose',
        '#views-exposed-form-acquia-search-block-1',
        context
      ).forEach(searchForm => {
        searchForm.addEventListener('click', function (e) {
          // Check if click is on the close icon area (right side)
          const rect = searchForm.getBoundingClientRect();
          const clickX = e.clientX - rect.left;
          const formWidth = rect.width;

          // If click is in the right 30px area, treat as close
          if (clickX > formWidth - 30) {
            e.preventDefault();
            e.stopPropagation();

            const searchInput = document.querySelector(
              '#edit-search-api-fulltext,#edit-search-api-fulltext--2, #edit-search-api-fulltext--3'
            );

            if (searchInput && searchForm.classList.contains('active')) {
              // Remove active classes to trigger closing transition
              searchInput.classList.remove('active');
              searchForm.classList.remove('active');

              // Hide the input after transition completes
              setTimeout(() => {
                if (!searchInput.classList.contains('active')) {
                  searchInput.style.display = 'none';
                }
              }, 300);
            }
            return false;
          }
        });
      });

      // Add input monitoring for search-ready state
      once(
        'searchInputMonitor',
        '#edit-search-api-fulltext, #edit-search-api-fulltext--2, #edit-search-api-fulltext--3',
        context
      ).forEach(searchInput => {
        const customSubmitBtn = document.querySelector(
          '.custom-submit-btn.search-toggle'
        );

        searchInput.addEventListener('input', function () {
          if (customSubmitBtn) {
            if (this.value.trim() !== '') {
              customSubmitBtn.classList.add('search-ready');
            } else {
              customSubmitBtn.classList.remove('search-ready');
            }
          }
        });

        // Also check on focus/blur
        searchInput.addEventListener('focus', function () {
          if (customSubmitBtn && this.value.trim() !== '') {
            customSubmitBtn.classList.add('search-ready');
          }
        });

        searchInput.addEventListener('blur', function () {
          if (customSubmitBtn) {
            customSubmitBtn.classList.remove('search-ready');
          }
        });
      });
    },
  };

  // Update search icon for specific block
  Drupal.behaviors.updateSearchIcon = {
    attach: function (context, settings) {
      once(
        'updateSearchIcon',
        '#block-colorlines-exposedformacquia-searchblock-1-2',
        context
      ).forEach(block => {
        const searchIcon = block.querySelector('.custom-submit-btn img');
        if (searchIcon) {
          searchIcon.src =
            '/themes/custom/colorlines/assets/images/svg/search-white.svg';
          searchIcon.classList.add('white-magnifying');
        }
      });
    },
  };

  // Search utilities.
  Drupal.behaviors.searchUpdates = {
    attach: function (context, settings) {
      once('customSubmit', '.custom-submit-btn', context).forEach(
        customSubmitBtn => {
          customSubmitBtn.addEventListener('click', function (e) {
            e.preventDefault();

            // Check if we just want to show/hide the search input.
            if (customSubmitBtn.classList.contains('search-toggle')) {
              // Don't trigger search, just return (handled by searchToggle behavior).
              return;
            }

            const orgSubmitBtn = document.querySelector(
              'form #edit-submit-acquia-search'
            );
            if (orgSubmitBtn) {
              orgSubmitBtn.click();
            }
          });
        }
      );

      once(
        'updateSearchString',
        '.view-id-acquia_search form input[name="search_api_fulltext"]',
        context
      ).forEach(customSubmitBtn => {
        const header = document.querySelector(
          '.view-id-acquia_search .view-header'
        );
        if (header) {
          if (customSubmitBtn.value) {
            header.innerHTML = header.innerHTML.replace(
              '@searched_string',
              '<strong>"' + customSubmitBtn.value + '"</strong>'
            );
          } else {
            header.innerHTML = '';
          }
        }
      });

      once(
        'autoSubmit',
        '.view-id-acquia_search form select[name="sort_by"]',
        context
      ).forEach(sortBySelect => {
        sortBySelect.addEventListener('change', function (e) {
          const orgSubmitBtn = document.querySelector(
            '.view-id-acquia_search form #edit-submit-acquia-search'
          );
          if (orgSubmitBtn) {
            orgSubmitBtn.click();
          }
        });
      });
    },
  };
})(Drupal, once);
